import React from "react";
import {
  FaFileAlt,
  FaFileExcel,
  FaFileImage,
  FaFilePdf,
  FaFileWord,
} from "react-icons/fa";
import { FiFile } from "react-icons/fi";

export function getFileIcon(fileType: string): React.ReactElement {
  const lowerType = fileType.toLowerCase();

  if (lowerType.includes("pdf")) {
    return <FaFilePdf className="h-5 w-5 text-status-error-text" />;
  }
  if (
    lowerType.includes("image") ||
    lowerType.includes("png") ||
    lowerType.includes("jpg") ||
    lowerType.includes("jpeg")
  ) {
    return <FaFileImage className="h-5 w-5 text-status-success-text" />;
  }
  if (
    lowerType.includes("excel") ||
    lowerType.includes("xls") ||
    lowerType.includes("spreadsheet")
  ) {
    return <FaFileExcel className="h-5 w-5 text-status-success-text" />;
  }
  if (
    lowerType.includes("word") ||
    lowerType.includes("wordprocessing") ||
    lowerType === "application/msword"
  ) {
    return <FaFileWord className="h-5 w-5 text-primary" />;
  }
  if (
    lowerType.includes("text") ||
    lowerType.includes("txt") ||
    lowerType.includes("rtf")
  ) {
    return <FaFileAlt className="h-5 w-5 text-muted-foreground" />;
  }

  return <FiFile className="h-5 w-5 text-foreground-muted" />;
}
